import { useState, memo, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./style.css";
import AuthenticationForms from "./AuthenticationForms";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import FieldInput from "src/component/FieldInput/FieldInput";
import { useForm } from "src/hooks/useForm";
import SubmitBtn from "src/component/ActionBtn/SubmitBtn";
import { handleAuthSuccess } from "src/utils";
import { Context } from "src/context";
import { Login } from "src/requests/user";

const default_cred = { phone: "", password: "" };

const LoginC = () => {

  const [loading, setLoading] = useState(false);

  const { setIsLoggedIn } = useContext(Context);

  const { register, handleSubmit } = useForm();

  const { executeRecaptcha } = useGoogleReCaptcha();

  const { t } = useTranslation();

  const navigate = useNavigate()

  const onSubmit = (data: any) => {
    if (!executeRecaptcha) return;

    executeRecaptcha('login').then(recaptchToken => {
      setLoading(true);

      let requestBody = {
        phoneNumber: data.phone.value,
        password: data.password.value
      }

      Login(requestBody).then((result: any) => {
        if (result.data.data.token) {
          handleAuthSuccess({
            data: result.data.data.token,
            setIsLoggedIn: setIsLoggedIn
          });
          navigate("/")
        }
        else {
          navigate("/two-factor-auth", {
            state: {
              requires2Fa: result?.data?.data?.requires2Fa,
              requiresEnrollment: result?.data?.data?.requiresEnrollment,
              enrollmentToken: result?.data?.data?.enrollmentToken,
              challengeToken: result?.data?.data?.challengeToken
            }
          })
        }
      }).catch(() => {
      }).finally(() => {
        setLoading(false);
      }
      );
    })
  }

  return (
    <AuthenticationForms>
      <div className="login-content-header">
        <span className="login-content-header-title">{t("loginTitle")}</span>
        <span className="login-content-header-cta">{t("phone-pass-cta")}</span>


      </div>
      <div className="inputs-container">
        <FieldInput label="phone" isRequired {...register("phone")} defaultValue={default_cred?.phone} />
        <FieldInput label="password" isRequired {...register("password")} defaultValue={default_cred?.password} />

      </div>

      <Link to="/passwordCode" className="forget-password-link">
        {t("forgetPassword")}
      </Link>
      <SubmitBtn onSubmit={handleSubmit(onSubmit)} loading={loading} label="login" />

    </AuthenticationForms>
  );
};

export default memo(LoginC);
